import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import SoilTest from '@/models/SoilTest.js'

export const useSoilTestStore = defineStore('soilTestStore', () => {

  let syncableModel = useSyncableModel(useApiResource('soil_tests'), {
    className: SoilTest.modelName.name,
    paramKey: SoilTest.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }
}, {
  persist: true
})